import { BannerSliderProps } from "@omni/types/components/props/bannerSlider.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { ProgressBarContextProvider } from "./components/progressBar/context/progressBar.context";
import { BannerSliderContextProvider } from "./context/bannerSlider.context";

const Base = ({
    bannerSlides,
    delay,
    speed,
    trackingProps,
    children
}: RequireChildrenFor<BannerSliderProps>) => {
    return (
        <BannerSliderContextProvider
            delay={delay}
            speed={speed}
            slides={bannerSlides}
            trackingProps={trackingProps}
        >
            <ProgressBarContextProvider>{children}</ProgressBarContextProvider>
        </BannerSliderContextProvider>
    );
};

export { Base };
